module.exports = __webpack_public_path__ + "kudos_60.svg?64ce8796ac2b8ce2e0822f9aec200be6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_60.svg
// module id = 162
// module chunks = 0